import React from 'react'
import { useStyles } from './TechlinkNavigationButton_style'
import { Button } from '@material-ui/core'

import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'

const TechlinkNavigationButton = (props) => {
    const { name, url } = props
    const classes = useStyles()

    return (
        <RouteMapLink page={url} className={classes.link}>
            <Button
                className={`${classes.navigationButton} ${classes.navigationButtonNonActive}`}
                disableRipple
            >
                {name}
            </Button>
        </RouteMapLink>
    )
}

export default TechlinkNavigationButton
